
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'

import './TruncateAndTooltip.scss'

const TruncateAndTooltip = ({ text, className, data, onClickCallback, wrapperEl, wrapperClassName }) => {
  const classContainer = classNames('truncate-and-tooltip', className, {
  })
  const ref = useRef(null)
  const [textTooltip, setTextTooltip] = useState('')

  useEffect(() => {
    ReactTooltip.rebuild()
    return () => {
      ReactTooltip.rebuild()
    }
  }, [])

  useEffect(() => {
    setTooltip()
  }, [ref, text])

  function setTooltip () {
    if (ref.current && ref.current.offsetWidth < ref.current.children[0].offsetWidth) {
      setTextTooltip(text)
    } else {
      setTextTooltip('')
    }
  }

  function handleOnCLick () {
    if (onClickCallback) {
      onClickCallback(data)
    }
  }

  function renderText () {
    return (wrapperEl) ? React.createElement(wrapperEl, { className: wrapperClassName }, text) : text
  }

  return (
    <div>
      <div className={classContainer} data-tip={textTooltip} ref={ref} onClick={handleOnCLick}>
        {renderText()}
      </div>
    </div>

  )
}

TruncateAndTooltip.defaultProps = {
  wrapperEl: 'span'
}

TruncateAndTooltip.propTypes = {
  wrapperEl: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string

}

export default TruncateAndTooltip
